import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Tabs as MuiTabs, Tab } from '@mui/material'
import { BORDERRADIUS as borderRadius, fontFamilies } from "@fedsim/constants"
import { PALETTE } from "@fedsim/constants";
import { styled } from '@mui/material/styles'

import { NOOP } from './shared'

export const AntTabs = styled(props => <MuiTabs {...props} />)(() => ({
  backgroundColor: PALETTE.TABS,
  overflow: 'hidden',
  borderRadius,
  '& .MuiTabs-indicator': {
    height: '4px'
  }
}))

export const AntTab = styled(props => <Tab {...props} />)(
  ({ theme }) => ({
    borderBottom: `0px solid transparent`,
    borderLeft: 0,
    borderRight: 0,
    borderTop: 0,
    fontFamily: fontFamilies.secondaryFont,
    fontSize: 16,
    fontWeight: theme.typography.fontWeight,
    marginRight: 0,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    textTransform: 'none',
    color: 'white',
    backgroundColor: PALETTE.TABS,
    
    '&.Mui-selected:hover, &:hover': {
      opacity: 1,
      borderBottom: `none`,
      borderLeft: 0,
      borderRight: 0,
      borderTop: 0,
      color: 'white'
    },
    '&.Mui-selected': {
      borderBottom: `none`,
      borderLeft: 0,
      borderRight: 0,
      borderTop: 0,
      color: 'white',
      fontWeight: theme.typography.fontWeightMedium + 100
    },
    '&.Mui-focusVisible': {
      backgroundColor: '#fef'
    }
  })
)

export function a11yProps (index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`
  }
}

export function TabPanel (props) {
  const { children, value, index, ...other } = props

  return (
    <Box
      variant='h5'
      component='div'
      role='tabpanel'
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box py={1}>{children}</Box>}
    </Box>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
}

export const Tabs = ({ collection = [], onChange = NOOP, defaultValue = 0 }) => {
  const [value, setValue] = useState(defaultValue)

  const handleChange = useCallback((event, newValue) => {
    onChange(newValue)

    setValue(newValue)
  }, [onChange])

  return (
    <Box sx={{ overflow: 'hidden' }}>
      <AntTabs
        value={value}
        onChange={handleChange}
        orientation='horizontal'
        indicatorColor="primary"
        aria-label='tabs'
        variant="scrollable"
        scrollButtons="auto"
      >
        {collection.map(({ label, value, highlight = false }, index) => (
          <AntTab
            key={label}
            label={`${label} ${highlight ? '*' : ''}`}
            value={value}
            {...a11yProps(index)}
          />
        ))}
      </AntTabs>
      {collection.map(({ label, PresentationItem }, index) => (
        <TabPanel key={label} value={value} index={index}>
          <PresentationItem />
        </TabPanel>
      ))}
    </Box>
  )
}

Tabs.propTypes = {
  collection: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
      PresentationItem: PropTypes.func.isRequired
    })
  ).isRequired,
  onChange: PropTypes.func,
  defaultValue: PropTypes.any
}

export default Tabs
